class BrowserFingerPrint {
  fingerprintToString;

  AttrException = ['appVersion', 'userAgent'];

  debug = false;

  isAttrException = function (needle) {
    const haystack = this.AttrException;
    const { length } = haystack;
    for (let i = 0; i < length; i++) {
      if (typeof haystack[i] === 'object') {
        return false;
      }
      return false;
    }
    return true;
  };

  ListAllScreenAttributesAndMethods=function () {
    let debugString = 'Attributes of the SCREEN object (in lexicographical order) <br>\n<br>\n';
    const arrScreenProperties = [];
    if (window.screen && document.addEventListener) {
      for (const EachProperty in window.screen) {
        arrScreenProperties.push(EachProperty);
      }

      arrScreenProperties.sort(); // in lexicographical order
      for (let PropertyIterator = 0; PropertyIterator < arrScreenProperties.length; PropertyIterator++) {
        if (this.isAttrException(arrScreenProperties[PropertyIterator])) {
          if (this.isPropString(window.screen[arrScreenProperties[PropertyIterator]])) {
            debugString += `. ${arrScreenProperties[PropertyIterator]} = ${window.screen[arrScreenProperties[PropertyIterator]]}<br>\n`;
          }
          this.setFingerprint(window.screen[arrScreenProperties[PropertyIterator]]);
        }
      }

      if (this.debug === true) { this.showAttributes(debugString); }// fin debug
    } else if (document.all && !window.opera && document.compatMode && document.compatMode === 'CSS1Compat') {
      debugString += `availHeight = ${window.screen.availHeight}<br>\n`;
      debugString += `availWidth = ${window.screen.availWidth}<br>\n`;
      debugString += `height = ${window.screen.height}<br>\n`;
      debugString += `width = ${window.screen.width}`;
      if (this.debug === true) {
        this.showAttributes(debugString);
      }
      this.setFingerprint(window.screen.availHeight);
      this.setFingerprint(window.screen.availWidth);
      this.setFingerprint(window.screen.height);
      this.setFingerprint(window.screen.width);
    }
  };

  browserSyst = () => {
    let OSName = 'unknown OS';
    if (navigator.appVersion.indexOf('Win') !== -1) OSName = 'Windows';
    if (navigator.appVersion.indexOf('Mac') !== -1) OSName = 'MacOS';
    if (navigator.appVersion.indexOf('X11') !== -1) OSName = 'UNIX';
    if (navigator.appVersion.indexOf('Linux') !== -1) OSName = 'Linux';
    let is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    const is_explorer = (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0);
    const is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
    let is_safari = navigator.userAgent.indexOf('Safari') > -1;
    const is_opera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
    if ((is_chrome) && (is_safari)) { is_safari = false; }
    if ((is_chrome) && (is_opera)) { is_chrome = false; }
    if (is_chrome) {
      return `chrome/${OSName}`;
    }
    if (is_explorer) {
      return `explorer/${OSName}`;
    }
    if (is_firefox) {
      return `firefox/${OSName}`;
    }
    if (is_safari) {
      return `safari/${OSName}`;
    }
    if (is_opera) {
      return `opera/${OSName}`;
    }
    return `nobrowser/${OSName}`;
  }

  isPropString = function (v) {
    if (typeof (v) !== 'function' && typeof (v) !== 'object') {
      return true;
    }
    return false;
  };

  setVerbose = function (v) {
    if (this.debug === true) console.log(v);
  };

  setFingerprint = function (v) {
    if (this.isPropString(v)) {
      this.fingerprintToString += v;
    }
  };

  showAttributes = function (debugString) {
    this.setVerbose(debugString);
  };

  ListAllNavigatorAttributesAndMethods=function () {
    let debugString = 'Attributes NAVIGATOR object <br>\n<br>\n';

    const arrNavigatorProperties = [];

    for (const EachProperty in navigator) {
      if (EachProperty !== 'ListNavigatorProperties') {
        arrNavigatorProperties.push(EachProperty);
      }
    }

    arrNavigatorProperties.sort(); // in lexicographical order
    for (let PropertyIterator = 0; PropertyIterator < arrNavigatorProperties.length; PropertyIterator++) {
      if (this.isAttrException(arrNavigatorProperties[PropertyIterator])) {
        if (this.isPropString(navigator[arrNavigatorProperties[PropertyIterator]])) {
          debugString += `. ${arrNavigatorProperties[PropertyIterator]} = ${navigator[arrNavigatorProperties[PropertyIterator]]}<br>\n`;
        }
        this.setFingerprint(navigator[arrNavigatorProperties[PropertyIterator]]);
      } else if (arrNavigatorProperties[PropertyIterator] === 'userAgent') {
        debugString += `. ${arrNavigatorProperties[PropertyIterator]} (tocado) = ${this.browserSyst()}<br>\n`;
        this.setFingerprint(this.browserSyst());
      }//
    }
    if (this.debug === true) {
      this.showAttributes(debugString);
    }
  };

  encodeToHex=function (str) {
    let result = 0;
    for (let i = 0; i < str.length; i++) {
      // result += str.charCodeAt(i).toString(16);
      result = result + i + (str.charCodeAt(i));
    }
    return result;
  };

  getFingerprint=function (v) {
    return this.fingerprintToString;
  };

  fingerprint=function () {
    this.browserSyst();
    this.ListAllScreenAttributesAndMethods();
    this.ListAllNavigatorAttributesAndMethods();
    return this.encodeToHex(this.getFingerprint());
  };
}

export default BrowserFingerPrint;
